module.exports = __webpack_public_path__ + "media/images/client-35-9ec199b68d001751a720d19b1debfa06.png";